exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --scrollbar-bg: var(--noreaster);\n  --scrollbar-color: rgba(0, 0, 0, 0.3);\n}\n\n::-webkit-scrollbar {\n  height: 10px;\n  width: 10px;\n}\n\n::-webkit-scrollbar-button {\n  display: none;\n  height: 0;\n  width: 0;\n}\n\n::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--scrollbar-bg);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-color);\n  border: 2px solid var(--scrollbar-bg);\n  border-radius: 8px;\n}\n", ""]);

// exports
